module.exports = __webpack_public_path__ + "img/704.212d56a8.png";